import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ranjangaonganpat() {



    const cardData =
    {
        keyword: 'Ranjangaon Ganpati – Nighoj Kund – Morachi Chincholi School Picnic',
        heading: 'Anand Krushi Paryatan Kendra: Ranjangaon Ganpati – Nighoj Kund – Morachi Chincholi School Picnic',
        headingDescription: 'Planning a memorable Ranjangaon Ganpati – Nighoj Kund – Morachi Chincholi school picnic? Make Anand Krushi Paryatan Kendra your ideal final stop to complete the day with fun, culture, and learning. Situated near Morachi Chincholi and just a short drive from both Ranjangaon and Nighoj, this 40-acre agri-tourism destination offers students an exciting blend of rural activities and educational exposure. After visiting the historic Ranjangaon Ganpati temple and exploring the natural wonder of Nighoj"s potholes, students can enjoy tractor and bullock cart rides, horse riding, boating, swimming, and a vibrant rain dance at Anand Krushi. The center also hosts cultural shows like magic and puppetry, plus traditional village games that promote teamwork and engagement. For schools planning a full-day picnic covering heritage, nature, and rural fun, this well-rounded route is the perfect itinerary.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',
"topPlaces": [
  {
    "title": "Ranjangaon Ganpati Temple Visit",
    "description": "Start the journey with a respectful visit to the famous Ranjangaon Ganpati temple—students can learn about temple architecture, mythology, and cultural traditions in a calm, spiritual atmosphere."
  },
  {
    "title": "Nighoj Kund Geological Tour",
    "description": "Explore the unique natural sinkholes ('kunds') at Nighoj—understand rock erosion, earth science, and capture remarkable geological formations through guided observations."
  },
  {
    "title": "Peacock Spotting & Nature Trails",
    "description": "At Anand Krushi Paryatan Kendra, begin with guided nature walks through farmland and orchards, where students can spot free-roaming peacocks, parakeets, and bulbuls."
  },
  {
    "title": "Bullock Cart & Tractor Rides",
    "description": "Enjoy fun rides across village tracks in decorated bullock carts and farm tractors—ideal for all ages and insightful into rural transport traditions."
  },
  {
    "title": "Traditional Village Games",
    "description": "Organise group games like kho-kho, kabaddi, lagori, sack race, and gilli-danda on open lawns to promote teamwork, physical fitness, and cultural bonding."
  },
  {
    "title": "Interactive Farm Learning",
    "description": "Hands-on stations led by local farmers where students plant seeds, water saplings, build compost pits, and learn about seasonal crops and organic practices."
  },
  {
    "title": "Animal Feeding & Dairy Visit",
    "description": "At the farm’s dairy section, students can feed calves, observe milking demos, and interact with goats and ducks—learning animal care first‑hand."
  },
  {
    "title": "Craft & Diya-Painting Workshops",
    "description": "Set up clay pottery, diya painting, and leaf-print crafts—students create their own souvenirs, exploring creativity and local artisan traditions."
  },
  {
    "title": "Nutritious Rural Meals",
    "description": "Enjoy home-cooked Maharashtrian-style meals served on banana leaves—poha or upma breakfast, unlimited thali lunch, and evening snacks included."
  },
  {
    "title": "Puppet/Magic Show & Cultural Fun",
    "description": "Cap off the visit with lively puppet shows, magic acts, or folk storytelling in a shaded outdoor setting—blending entertainment with cultural learning."
  }
],




"services": [
  {
    "name": "One-Day Pilgrimage and Educational Nature Trip",
    "description": "A thoughtfully designed day trip combining spiritual visits and immersive nature experiences. Students visit Ranjangaon Ganpati temple for cultural and religious learning, followed by interactive sessions at Morachi Chincholi farm, blending devotion with hands-on eco-education."
  },
  {
    "name": "Ranjangaon Ganpati Darshan and Village Walk",
    "description": "Students experience the spiritual ambiance of one of the Ashtavinayak pilgrimage sites, complemented by guided village walks that showcase rural lifestyles, traditional farming, and folk customs, enriching their understanding of local heritage."
  },
  {
    "name": "Geological Learning at Nighoj Kund",
    "description": "Explore the natural wonder of Nighoj’s potholes with geology experts explaining rock formations, water erosion, and local ecosystem interconnections, turning the landscape into an open-air science classroom."
  },
  {
    "name": "Farm-Based Education at Morachi Chincholi",
    "description": "Hands-on farming activities, animal interaction zones, and ecological lessons at the famous Morachi Chincholi provide students with real-world knowledge of sustainable agriculture and biodiversity."
  },
  {
    "name": "Educational Religious Circuit Near Pune",
    "description": "An integrated itinerary covering temples, village cultural experiences, and nature exploration to offer a holistic learning environment combining history, spirituality, and environmental science."
  },
  {
    "name": "Combined Cultural and Nature Picnic",
    "description": "Students enjoy traditional folk music, dance, and craft sessions alongside nature trails and farm games, ensuring a balanced mix of cultural exposure and ecological learning."
  },
  {
    "name": "Full-Day Multi-Spot School Tour",
    "description": "An efficient and engaging full-day itinerary that includes temple visits, farm tours, geological site study, and bird sanctuary stops — maximizing educational value while keeping students energized and engaged."
  },
  {
    "name": "Budget-Friendly Multi-Spot Picnic Packages",
    "description": "Affordable group packages designed to fit school budgets without compromising on quality, covering transport, meals, guided sessions, and entry to multiple sites for a well-rounded experience."
  },
  {
    "name": "Bird Sanctuary Visit with Historical Exploration",
    "description": "A visit to nearby bird sanctuaries paired with exploration of adjacent historical landmarks, allowing students to connect ecological awareness with regional history."
  },
  {
    "name": "Group Booking and Logistics Support",
    "description": "Complete assistance in group coordination, permission paperwork, transport bookings, and on-site guidance ensures smooth, hassle-free management for school administrators and teachers."
  }
],
"tableData": [
  ["One-Day Pilgrimage and Educational Nature Trip", "Ranjangaon Ganpati Darshan and Village Walk"],
  ["Geological Learning at Nighoj Kund", "Farm-Based Education at Morachi Chincholi"],
  ["Educational Religious Circuit Near Pune", "Combined Cultural and Nature Picnic"],
  ["Full-Day Multi-Spot School Tour", "Budget-Friendly Multi-Spot Picnic Packages"],
  ["Bird Sanctuary Visit with Historical Exploration", "Group Booking and Logistics Support"]
],



"whychoose": [
  {
    "WhyChooseheading": "Unique Multi-Spot School Picnic Experience",
    "WhyChoosedescription": "Anand Krushi Paryatan Kendra offers an exciting school picnic package that includes visits to iconic locations like Ranjangaon Ganpati, the stunning Nighoj Kund natural potholes, and the vibrant Morachi Chincholi village, providing a diverse mix of spirituality, geology, and rural culture."
  },
  {
    "WhyChooseheading": "Cultural and Spiritual Exploration",
    "WhyChoosedescription": "Students get the opportunity to explore the famous Ranjangaon Ganpati temple, one of the Ashtavinayak pilgrimage sites, learning about the rich religious heritage and cultural traditions of Maharashtra."
  },
  {
    "WhyChooseheading": "Natural Wonders and Adventure at Nighoj Kund",
    "WhyChoosedescription": "The visit to Nighoj Kund lets students witness the world’s largest natural potholes, formed over thousands of years by the flowing river water, offering a hands-on geology lesson in a breathtaking natural setting."
  },
  {
    "WhyChooseheading": "Engaging Rural Life Experience at Morachi Chincholi",
    "WhyChoosedescription": "Morachi Chincholi, known for its beautiful rural landscape and peacock sanctuary, provides students with a chance to experience traditional village life, interact with nature, and enjoy activities like bullock cart rides and farm tours."
  },
  {
    "WhyChooseheading": "Comprehensive Educational and Recreational Package",
    "WhyChoosedescription": "The picnic combines educational tours, cultural exposure, and outdoor fun, ensuring that students gain knowledge while enjoying memorable group activities in safe, supervised environments."
  },
  {
    "WhyChooseheading": "Convenient Access and Well-Organized Itinerary",
    "WhyChoosedescription": "Located within easy reach of Pune, Anand Krushi Paryatan Kendra coordinates smooth transportation and a well-structured schedule to maximize the learning and enjoyment within a day trip."
  }
]


































    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Why is the Ranjangaon Ganpati – Nighoj Kund – Morachi Chincholi route ideal for a school picnic?',
    answer: 'This route offers a well-balanced mix of cultural, geographical, and recreational experiences. Students can learn about spirituality at Ranjangaon Ganpati, witness natural rock formations at Nighoj Kund, and enjoy fun rural activities at Morachi Chincholi.',
  },
  {
    id: 'FAQ2',
    question: 'What educational value does this picnic route offer?',
    answer: 'Students get to learn about Maharashtra’s Ashtavinayak temples at Ranjangaon, geological wonders at Nighoj’s potholes, and agro-tourism practices at Morachi Chincholi, blending science, history, and nature in one day.',
  },
  {
    id: 'FAQ3',
    question: 'What kind of activities are conducted for students at Morachi Chincholi?',
    answer: 'At Morachi Chincholi, students enjoy bullock cart rides, tractor rides, bird watching (especially peacocks), rain dance, traditional games, and farm visits – all in a safe, guided setup.',
  },
  {
    id: 'FAQ4',
    question: 'Is this school picnic route suitable for a one-day trip?',
    answer: 'Yes, all three locations are within close proximity (within ~80 km radius from Pune), allowing a full-day itinerary that begins in the morning and concludes by evening.',
  },
  {
    id: 'FAQ5',
    question: 'Are meals and refreshments included in the picnic package?',
    answer: 'Yes, at Morachi Chincholi, picnic organizers usually provide breakfast, lunch, and evening snacks. The meals are vegetarian, hygienic, and locally prepared.',
  },
  {
    id: 'FAQ6',
    question: 'Is the route safe and manageable for school students?',
    answer: 'Absolutely. Each spot is child-friendly, with proper safety arrangements, washroom facilities, and trained staff or guides to assist school groups.',
  },
  {
    id: 'FAQ7',
    question: 'How long does this combined picnic usually take?',
    answer: 'The picnic typically spans from 7:30 AM to 6:00 PM, covering temple visit, geological site exploration, and recreational activities at Morachi Chincholi.',
  },
  {
    id: 'FAQ8',
    question: 'Is prior booking required for this picnic route?',
    answer: 'Yes, especially for Morachi Chincholi. It’s advisable to book the picnic package and meals at least 2-3 weeks in advance to ensure arrangements for large school groups.',
  },
  {
    id: 'FAQ9',
    question: 'Is transportation arranged by the picnic organizers?',
    answer: 'Transportation can either be arranged by the school or coordinated with organizers who offer group transport options including buses and local guides.',
  },
  {
    id: 'FAQ10',
    question: 'Are rest areas and washroom facilities available along the route?',
    answer: 'Yes, all three destinations have suitable rest stops, shaded seating, and clean washrooms to ensure a comfortable journey for both students and teachers.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Kavita Deshpande, School Coordinator, Pune',
    feedback: "This combination of Ranjangaon, Nighoj, and Morachi Chincholi was the perfect educational picnic for our students. It was well-planned, informative, and full of fun!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Prashant Jagtap, Teacher, Pimpri-Chinchwad',
    feedback: "Students were amazed by the Nighoj Kund rock formations, enjoyed the peaceful temple visit, and had a blast at Morachi Chincholi. A great blend of learning and enjoyment!",
    rating: 5,
  },
];





































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];
const schoolTripCircuitSchema = {
  "@context": "https://schema.org",
  "@type": "EducationalOccupationalProgram",
  "name": "Ranjangaon Ganpati – Nighoj Kund – Morachi Chincholi School Picnic",
  "description": "Plan a full-day school picnic combining religious, geological, and agro-tourism learning. Visit Ranjangaon Ganpati temple, explore Nighoj Kund's natural formations, and engage in eco-tourism at Morachi Chincholi's Anand Krushi Paryatan Kendra.",
  "educationalProgramMode": "OnSite",
  "provider": {
    "@type": "Organization",
    "name": "Anand Krushi Paryatan Kendra",
    "url": "https://morachichincholi.in/"
  },
  "hasCourse": [
    {
      "@type": "Course",
      "name": "Cultural & Religious Education",
      "description": "Visit Ranjangaon Ganpati Temple to understand Maharashtra’s spiritual heritage."
    },
    {
      "@type": "Course",
      "name": "Geological Learning",
      "description": "Explore the naturally formed potholes and rocks of Nighoj Kund."
    },
    {
      "@type": "Course",
      "name": "Eco & Farm Tourism",
      "description": "Interactive farm activities, bird watching, and rural games at Morachi Chincholi."
    }
  ],
  "url": "https://morachichincholi.in/ranjangaon-nighoj-morachi-school-tour"
};



    return (
        <div>

<Helmet>
  <title>Ranjangaon Ganpati – Nighoj Kund – Morachi Chincholi School Picnic | Religious, Geological & Eco Tour</title>
  <meta 
    name="description" 
    content="A one-day school picnic combining spiritual, scientific, and eco experiences. Visit Ranjangaon Ganpati, explore Nighoj Kund, and enjoy farm-based activities at Morachi Chincholi. Ideal for educational group outings from Pune." 
  />
  <meta 
    name="keywords" 
    content="School pilgrimage trip with education, One-day religious + nature trip for schools, School tour including Ranjangaon Ganpati, Geological learning at Nighoj Kund, Farm education at Morachi Chincholi, Educational religious circuit near Pune, Combined cultural + nature picnic, Full-day school tour itinerary near Pune, Budget-friendly multi-spot picnic trip, Ganpati darshan + village experience, Bird sanctuary visit with historical site, School package with temples and nature, Historical + science + eco-tour combo trip, Group bookings for school day circuit" 
  />
  <script type="application/ld+json">
    {JSON.stringify(schoolTripCircuitSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/48.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Ranjangaonganpat;